<template>
  <base-container ref="container" :isLoading="loading">
    <el-container style="height: 100%">
      <el-aside v-if="!query?.resId" width="200px" style="height: 100%">
        <artisan-group title="检验资源" style="height: 100%">
          <!-- <el-menu
            :default-active="resId"
            @select="selectRes"
            style="height: 100%"
          >
            <el-menu-item
              :index="res.id"
              v-for="res in resources"
              :key="res.id"
            >
              <i class="el-icon-menu"></i>
              <span slot="title">{{ res.name }}</span>
            </el-menu-item>
          </el-menu> -->
          <el-tree
            :data="resTree"
            :props="defaultProps"
            @node-click="handleNodeClick"
            default-expand-all
            :current-node-key="resId"
            :expand-on-click-node="false"
          >
            <span style="flex: 1" slot-scope="{ node, data }">
              <span :class="data.id==editRow.resId?'color-primary':''">{{ node.label }}</span>
            </span>
          </el-tree>
        </artisan-group>
      </el-aside>
      <el-main style="height: 100%; padding: 0">
        <div style="height: 50%; overflow: hidden">
          <el-table
            ref="table"
            header-row-class-name="back-gray1"
            header-cell-class-name="back-gray1"
            :data="tableData"
            border
            fit
            row-key="id"
            height="100%"
          >
            <el-table-column
              :prop="'week' + week.weekNo"
              v-for="week in weekList"
              :key="week.weekNo"
              :label="week.name"
              header-align="center"
              align="center"
              min-width="160"
            >
              <template slot-scope="{ row }">
                <ResourceRouteItem
                  :routeId="editRow.id"
                  :routes="row['week' + week.weekNo]"
                  @click="checkRoute"
                  @remove="removeRoute"
                ></ResourceRouteItem>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-row style="height: 50%">
          <el-col :span="10" style="height: 100%">
            <el-card style="height: 100%; overflow-y: auto">
              <el-row
                slot="header"
                type="flex"
                justify="space-between"
                align="middle"
              >
                <span>约束规则-{{ editRow.id ? "编辑" : "新增" }}</span>
                <div>
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-check"
                    @click="saveRoute()"
                  >
                    保存
                  </el-button>
                  <el-button
                    class="color-danger"
                    type="text"
                    size="mini"
                    icon="el-icon-setting"
                    @click="addRoute()"
                  >
                    重置
                  </el-button>
                </div>
              </el-row>
              <el-descriptions
                :labelStyle="{ width: '70px' }"
                :column="1"
                size="small"
                border
              >
                <el-descriptions-item label="是否启用">
                  <el-switch v-model="editRow.isValid"> </el-switch>
                </el-descriptions-item>
                <el-descriptions-item label="星期约束">
                  <el-select
                    size="mini"
                    style="width: 100%"
                    multiple
                    v-model="editRow.fitWeeks"
                  >
                    <el-option
                      v-for="week in weekList"
                      :key="week.weekNo"
                      multiple
                      :value="week.weekNo"
                      :label="week.name"
                    ></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="日期约束">
                  <el-date-picker
                    size="mini"
                    style="width: 100%"
                    type="dates"
                    v-model="editRow.fitDates"
                    value-format="yyyy-MM-dd"
                    placeholder="选择一个或多个日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </el-descriptions-item>
                <el-descriptions-item label="时段约束">
                  <el-tag
                    :key="i"
                    v-for="(period, i) in editRow.fitPeriods"
                    closable
                    :disable-transitions="false"
                    class="clickable margin3"
                    @close="closePeriod(editRow, period, i)"
                  >
                    {{ period }}
                  </el-tag>
                  <el-button
                    v-if="!editRow.isAddPeriod"
                    size="small"
                    @click="editRow.isAddPeriod = true"
                  >
                    + 新增时段
                  </el-button>
                  <div class="margin5" v-else>
                    <el-time-select
                      style="width: 120px"
                      size="mini"
                      placeholder="起始时间"
                      v-model="editRow.startTime"
                      :picker-options="{
                        start: '00:00',
                        step: '00:30',
                        end: '24:00',
                      }"
                    >
                    </el-time-select>
                    <span class="margin-h3">-</span>
                    <el-time-select
                      style="width: 120px"
                      size="mini"
                      placeholder="结束时间"
                      v-model="editRow.endTime"
                      :picker-options="{
                        start: '00:00',
                        step: '00:30',
                        end: '24:00',
                        minTime: editRow.startTime,
                      }"
                    >
                    </el-time-select>
                    <el-button
                      type="success"
                      :disabled="!editRow.startTime || !editRow.endTime"
                      style="margin-left: 5px"
                      size="mini"
                      @click="addPeriod(editRow)"
                    >
                      + 确认
                    </el-button>
                    <el-button
                      type="danger"
                      style="margin-left: 5px"
                      size="mini"
                      @click="editRow.isAddPeriod = false"
                    >
                      取消
                    </el-button>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="约束规则">
                  <el-select
                    style="width: 100%"
                    v-model="editRow.ruleGroupId"
                    size="mini"
                    placeholder="请选择规则模板"
                  >
                    <el-option
                      v-for="rule in rules"
                      :key="rule.id"
                      :value="rule.id"
                      :label="rule.name"
                    ></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item label="约束备注">
                  <el-input
                    v-model="editRow.remark"
                    size="mini"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入备注"
                  >
                  </el-input>
                  <div class="align-center" style="margin-top: 5px"></div>
                </el-descriptions-item>
              </el-descriptions>
            </el-card>
          </el-col>
          <el-col :span="14" style="height: 100%">
            <RuleTemplate
              :queryRuleId="viewRuleId"
              style="height: 100%"
            ></RuleTemplate>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </base-container>
</template>

<script>
import constant from "@/config/constant";
import RuleTemplate from "./RuleTemplate";
import ResourceRouteItem from "./assist/ResourceRouteItem";
import { getAuthResource } from "@/api/jy/reserve";
import { ruleList } from "@/api/jy/rule";
import { list, add, edit, remove } from "@/api/jy/route";
import { data } from "jquery";
export default {
  components: { RuleTemplate, ResourceRouteItem },
  props: ["query"],
  data() {
    return {
      loading: false,
      resList: [],
      weekList: constant.weeks,
      resources: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      resId: this.query.resId || "",
      routes: [],
      rules: [],
      editRow: {
        resId: "",
        sortNo: 0,
        fitWeeks: [],
        fitDates: [],
        fitPeriods: [],
        isAddPeriod: false,
        startTime: "",
        endTime: "",
        remark: "",
      },
      dialog: {
        show: false,
        title: "查看规则内容",
      },
      selectOptions: {
        start: "00:00",
        step: "00:30",
        end: "24:00",
      },
      pickerOptions: {
        format: "HH:mm",
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      viewRuleId: "",
    };
  },
  computed: {
    tableData() {
      let weekItems = {
        id: this.resId,
        week0: [],
        week1: [],
        week2: [],
        week3: [],
        week4: [],
        week5: [],
        week6: [],
        week7: [],
        week8: [],
      };
      this.routes.filter((c) =>
        c.fitWeeks.forEach((w) => {
          weekItems["week" + w].push(c);
        })
      );
      return [weekItems];
    },
    resTree() {
      let parents = this.resources.filter(
        (c) => !c.parentId || c.parentId == "0"
      );
      for (let index = 0; index < parents.length; index++) {
        const parent = parents[index];
        let childs = this.resources.filter((c) => c.parentId == parent.id);
        parent.children = childs || [];
      }
      return parents;
    },
  },
  created() {
    this.loadRuleList();
    getAuthResource().then((res) => {
      this.resources = res.data.data;
      if (this.resources.length) {
        if (!this.resId) this.resId = this.resources[0].id;
        this.editRow.resId = this.resId;
        this.loadRoutes();
      }
    });
  },
  methods: {
    loadRoutes() {
      this.loading = true;
      list(this.resId)
        .then((res) => {
          let data = res.data.data;
          data.forEach((c) => {
            c.fitWeeks = c.fitWeeks ? c.fitWeeks.split(",") : [];
            c.fitDates = c.fitDates ? c.fitDates.split(",") : [];
            c.fitPeriods = c.fitPeriods ? c.fitPeriods.split(",") : [];
            c.isAddPeriod = false;
            c.startTime = "";
            c.endTime = "";
          });
          this.routes = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleNodeClick(data) {
      this.resId = data.id;
      this.editRow.resId = data.id;
      this.loadRoutes();
      this.addRoute();
    },
    selectRes(index) {
      this.resId = index;
      this.loadRoutes();
    },
    loadRuleList() {
      ruleList().then((res) => {
        this.rules = res.data.data;
      });
    },
    checkRoute(id) {
      this.editRow = this.routes.find((c) => c.id == id);
      this.viewRuleId = this.editRow.ruleGroupId;
    },
    addRoute() {
      this.editRow = {
        resId: this.resId,
        sortNo: 0,
        fitWeeks: [],
        fitDates: [],
        fitPeriods: [],
        isAddPeriod: false,
        startTime: "",
        endTime: "",
        remark: "",
      };
      this.viewRuleId = "";
    },
    addPeriod() {
      if (this.editRow.isAddPeriod) {
        this.editRow.fitPeriods.push(
          this.editRow.startTime + "-" + this.editRow.endTime
        );
        this.editRow.startTime = "";
        this.editRow.endTime = "";
        this.editRow.isAddPeriod = false;
      }
    },
    closePeriod(route, period, i) {
      route.fitPeriods.splice(i, 1);
    },
    saveRoute() {
      if (!this.editRow.resId) {
        this.$message({
          type: "warning",
          message: "请先选择左侧的检验资源！",
        });
        return;
      }
      if (
        (this.editRow.fitWeeks.length || this.editRow.fitDates.length) &&
        this.editRow.fitPeriods.length &&
        this.editRow.ruleGroupId
      ) {
        this.$refs.container.confirm({ msg: "确认保存？" }).then(() => {
          this.loading = true;
          let data = Object.assign({}, this.editRow);
          if (this.editRow.fitWeeks)
            data.fitWeeks = this.editRow.fitWeeks.join(",");
          if (this.editRow.fitDates)
            data.fitDates = this.editRow.fitDates.join(",");
          if (this.editRow.fitPeriods)
            data.fitPeriods = this.editRow.fitPeriods.join(",");
          let operation = this.editRow.id ? edit : add;
          operation(data)
            .then((res) => {
              if (!this.editRow.id) {
                this.editRow.id = res.data.data.id;
                this.routes.push(this.editRow);
              }
              this.loading = false;
              this.$message({
                type: "success",
                message: "保存成功!",
              });
            })
            .catch(() => {
              this.loading = false;
            });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择星期约束(或日期约束)、时段约束和约束规则！",
        });
      }
    },
    removeRoute(id) {
      this.$refs.container.confirm({ msg: "确认删除？" }).then(() => {
        if (id) {
          this.loading = true;
          remove(id)
            .then(() => {
              this.loading = false;
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              const i = this.routes.findIndex((c) => c.id == id);
              this.routes.splice(i, 1);
              if (this.editRow.id == id) {
                this.editRow = {
                  resId: this.resId,
                  sortNo: 0,
                  fitWeeks: [],
                  fitDates: [],
                  fitPeriods: [],
                  isAddPeriod: false,
                  startTime: "",
                  endTime: "",
                  remark: "",
                };
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
